import { render, staticRenderFns } from "./apple_google_pay.vue?vue&type=template&id=a06db43a&"
import script from "./apple_google_pay.vue?vue&type=script&lang=js&"
export * from "./apple_google_pay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports